// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const PasteLine = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill={fill || 'none'}
      stroke={stroke}
      strokeWidth='2px'
    >
      <path d='M16.52,6.81h-5c-1,0-1.81-.68-1.81-1.53s.81-1.52,1.81-1.52h5c1,0,1.81.68,1.81,1.52s-.81,1.53-1.81,1.53Z' />
      <path d='M18.33,5.28c0,.85-.81,1.53-1.81,1.53h-5c-1,0-1.81-.68-1.81-1.53s.81-1.52,1.81-1.52h5c1,0,1.81.68,1.81,1.52Z' />
      <path d='M6.07,33.55h-1.03c-1.72,0-3.12-1.17-3.12-2.62V7.9c0-1.45,1.4-2.62,3.12-2.62h2.82' />
      <path d='M20.18,5.28h2.82c1.72,0,3.12,1.17,3.12,2.62v3.78' />
      <path d='M46.08,14.61v19.87c0,1.62-1.31,2.93-2.93,2.93h-12.08c-.36,0-.7.18-.88.49l-3.68,6.09c-.21.33-.68.33-.88,0l-3.68-6.09c-.18-.31-.52-.49-.88-.49h-12.06c-1.62,0-2.93-1.31-2.93-2.93V14.61c0-1.62,1.31-2.93,2.93-2.93h34.14c1.62,0,2.93,1.31,2.93,2.93Z' />
      <line x1='12.78' y1='23.97' x2='39.39' y2='23.97' />
      <line x1='12.76' y1='30.47' x2='27.61' y2='30.47' />
      <line x1='12.78' y1='17.47' x2='39.39' y2='17.47' />
    </svg>
  );
};
